export default __webpack_public_path__ + "static/media/Eye_7_F_C2.8a6bcedd.svg";